import * as React from "react";
import Menu from "@mui/material/Menu";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Tooltip from '@mui/material/Tooltip';
import { useSelector, useDispatch } from 'react-redux';
import { updateConclusion } from '../../../shared/model/redux/slide-reducer';
import { addFavoriteAsync, removeFavoriteAsync } from '../../../shared/model/redux/slides-reducer';
import updateSlideConclusion from '../../../shared/api/updateSlideConclusion';
import EditIcon from '@mui/icons-material/Edit';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';

import CheckboxWithChilds from "../atoms/CheckboxWithChilds";

export default function OverlaysHandler() {
    const dispatch = useDispatch();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [openModal, setOpenModal] = React.useState(false);
    const [conclusion, setConclusion] = React.useState('');
    const [snackbar, setSnackbar] = React.useState({ open: false, message: '', severity: 'success' });
    const open = Boolean(anchorEl);

    // Получаем данные текущего слайда из Redux
    const slideId = useSelector((store) => store.slide.data.id);
    const slideName = useSelector((store) => store.slide.data.name);
    const originalTissues = useSelector((store) => store.slide.data.tisuues);
    const hasTissues = Array.isArray(originalTissues) && originalTissues.length > 0;
    const currentConclusion = useSelector((store) => store.slide.data.conclusion);
    const slideData = useSelector((store) => store.slide.data);
    const favoriteSlides = useSelector((store) => store.slides.favoriteSlides);
    const isFavorite = favoriteSlides.some(s => s.id === slideId);

    const handleToggleFavorite = () => {
        if (isFavorite) {
            dispatch(removeFavoriteAsync(slideId));
        } else {
            dispatch(addFavoriteAsync(slideData));
        }
    };

    // При открытии модального окна загружаем текущее заключение
    React.useEffect(() => {
        if (openModal) {
            setConclusion(currentConclusion || '');
        }
    }, [openModal, currentConclusion]);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };


    const handleOpenModal = () => {
        setOpenModal(true);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
    };

    const handleSaveConclusion = async () => {
        try {
            await updateSlideConclusion(slideId, conclusion);
            // Обновляем состояние в Redux store
            dispatch(updateConclusion(conclusion));
            setSnackbar({
                open: true,
                message: 'Заключение успешно сохранено',
                severity: 'success'
            });
            handleCloseModal();
        } catch (error) {
            setSnackbar({
                open: true,
                message: 'Ошибка при сохранении заключения',
                severity: 'error'
            });
        }
    };

    const handleCloseSnackbar = () => {
        setSnackbar({ ...snackbar, open: false });
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div>
            <Button
                id="edit-button"
                onClick={handleOpenModal}
                style={{marginTop: '10px', minWidth: '40px', padding: '6px'}}
            >
                <EditIcon style={{width: '20px', height: '20px'}} />
            </Button>
            <Tooltip title={isFavorite ? 'Убрать из избранного' : 'Добавить в избранное'}>
                <Button
                    id="favorite-button"
                    onClick={handleToggleFavorite}
                    style={{marginTop: '10px', minWidth: '40px', padding: '6px'}}
                    color={isFavorite ? 'primary' : 'inherit'}
                >
                    {isFavorite
                        ? <BookmarkIcon style={{width: '20px', height: '20px'}}/>
                        : <BookmarkBorderIcon style={{width: '20px', height: '20px'}}/>
                    }
                </Button>
            </Tooltip>
            {hasTissues ? (
                <Button
                    id="basic-button"
                    aria-controls={open ? "basic-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? "true" : undefined}
                    onClick={handleClick}
                    style={{marginTop: '10px'}}
                >
                    Слои
                </Button>
            ) : (
                <span style={{
                    marginTop: '10px',
                    marginRight: '8px',
                    color: '#000',
                    fontSize: '0.95rem',
                    alignSelf: 'center',
                }}>
                    Патологий не обнаружено
                </span>
            )}
            <Dialog
                open={openModal}
                onClose={handleCloseModal}
                maxWidth="md"
                fullWidth
            >
                <DialogTitle><b>Заключение по слайду {slideName}</b></DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        multiline
                        rows={6}
                        margin="dense"
                        label="Введите заключение"
                        fullWidth
                        variant="outlined"
                        value={conclusion}
                        onChange={(e) => setConclusion(e.target.value)}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseModal} color="primary">
                        Отмена
                    </Button>
                    <Button onClick={handleSaveConclusion} color="primary" variant="contained" style={{
                            margin: '10px 19px',
                        }}>
                        Сохранить
                    </Button>
                </DialogActions>
            </Dialog>
            <Snackbar 
                open={snackbar.open} 
                autoHideDuration={6000} 
                onClose={handleCloseSnackbar}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert onClose={handleCloseSnackbar} severity={snackbar.severity}>
                    {snackbar.message}
                </Alert>
            </Snackbar>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    "aria-labelledby": "basic-button",
                }}
            >
                <MenuItem>
                    <CheckboxWithChilds
                        type="tissues"
                        label="Ткани"
                        // baseItems={tisuues}
                        // displayedItems={displayedTisuues}
                        // setItems={setDisplayedTisuues}
                    />
                </MenuItem>
                {/*<MenuItem>*/}
                {/*    <CheckboxWithChilds*/}
                {/*        type="annotations"*/}
                {/*        label="Аннотации"*/}
                {/*        // baseItems={annotations}*/}
                {/*        // displayedItems={displayedAnnotations}*/}
                {/*        // setItems={setDisplayedAnnotations}*/}
                {/*    />*/}
                {/*</MenuItem>*/}
            </Menu>
        </div>
    );
}
